export const getSebel = store => store.sebel
